/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MaschinenGruppe
 */
export interface MaschinenGruppe {
    /**
     * 
     * @type {string}
     * @memberof MaschinenGruppe
     */
    idName: string;
    /**
     * 
     * @type {string}
     * @memberof MaschinenGruppe
     */
    anzeigeName: string;
    /**
     * 
     * @type {number}
     * @memberof MaschinenGruppe
     */
    firmaId: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MaschinenGruppe
     */
    tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MaschinenGruppe
     */
    von: string;
    /**
     * 
     * @type {string}
     * @memberof MaschinenGruppe
     */
    bis?: string;
}

/**
 * Check if a given object implements the MaschinenGruppe interface.
 */
export function instanceOfMaschinenGruppe(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "idName" in value;
    isInstance = isInstance && "anzeigeName" in value;
    isInstance = isInstance && "firmaId" in value;
    isInstance = isInstance && "tags" in value;
    isInstance = isInstance && "von" in value;

    return isInstance;
}

export function MaschinenGruppeFromJSON(json: any): MaschinenGruppe {
    return MaschinenGruppeFromJSONTyped(json, false);
}

export function MaschinenGruppeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaschinenGruppe {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idName': json['idName'],
        'anzeigeName': json['anzeigeName'],
        'firmaId': json['firmaId'],
        'tags': json['tags'],
        'von': json['von'],
        'bis': !exists(json, 'bis') ? undefined : json['bis'],
    };
}

export function MaschinenGruppeToJSON(value?: MaschinenGruppe | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idName': value.idName,
        'anzeigeName': value.anzeigeName,
        'firmaId': value.firmaId,
        'tags': value.tags,
        'von': value.von,
        'bis': value.bis,
    };
}

